import { render, staticRenderFns } from "./AgendaCalendar.vue?vue&type=template&id=4ea21cba&scoped=true"
import script from "./AgendaCalendar.vue?vue&type=script&lang=js"
export * from "./AgendaCalendar.vue?vue&type=script&lang=js"
import style0 from "./agenda-calendar.scss?vue&type=style&index=0&id=4ea21cba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea21cba",
  null
  
)

export default component.exports